import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Md5 } from 'ts-md5/dist/md5';
import { Company } from 'src/app/models/company.model';
import { RequestService } from 'src/app/services/request.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RoleEnum } from 'src/app/models/enums/RoleEnum';
import { AuthenticationResponse } from 'src/app/models/authenticationresponse.model';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';
import { UserValidationRequest } from 'src/app/models/UserValidationRequest.model';
import { UserValidationResult } from 'src/app/models/UserValidationResult.model';
import { CreateUserRequest } from 'src/app/models/CreateUserRequest.model';

@Component({
  selector: 'app-usermanagement-list-add-user',
  templateUrl: './usermanagement-list-add-user.component.html',
  styleUrls: ['./usermanagement-list-add-user.component.scss']
})
export class UsermanagementListAddUserComponent implements OnInit, OnDestroy {
  form: FormGroup;
  button1: string = "Cancel";
  button2: string = "Create";
  title: string = "Create User";
  errors: string[] = [];
  companies: Company[] = [];
  isPasswordVisible: boolean = false;
  isPasswordRepeatVisible: boolean = false;
  private unscubscribe$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<UsermanagementListAddUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: AuthenticationResponse },
    private requestService: RequestService) {
    this.form = new FormGroup({
      email: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      repeatPassword: new FormControl(null, Validators.required),
      companyId: new FormControl(null, Validators.required)
    });

    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (this.data.user.roleId === RoleEnum["Super Admin"]) {
      this.loadCompanies();
      this.title = "Create Company Admin"
    }
  }

  loadCompanies() {
    this.requestService.getActiveAndBusinessActiveCompaniesWithoutSystemCompanyForAddUserDropdown()
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(resp => {
        this.companies = resp;
        this.companies.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));;
      });
  }

  cancel() {
    this.dialogRef.close({ save: false, data: null });
  }

  visibilityPassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  visibilityPasswordRepeat() {
    this.isPasswordRepeatVisible = !this.isPasswordRepeatVisible;
  }

  createUser() {
    let companyId = this.form.get('companyId').value;
    var mail = this.form.get('email').value;
    var password = this.form.get('password').value;
    var repeatPassword = this.form.get('repeatPassword').value;

    if (companyId == null) {
      companyId = this.data.user.companyId
    }

    this.requestService.maxActiveUsersReached(companyId).pipe(takeUntil(this.unscubscribe$))
      .subscribe((maxActiveUsersReached: boolean) => {
        if (maxActiveUsersReached === false) {
          let userValidationRequest: UserValidationRequest = {
            email: mail,
            password: password,
            repeatPassword: repeatPassword,
            companyId: companyId
          };

          this.requestService.validateUser(userValidationRequest).pipe(takeUntil(this.unscubscribe$))
            .subscribe((response: UserValidationResult) => {
              if (response.success) {

                const md5 = new Md5();
                let hashedPw: string = md5.appendStr(password).end().toString();
                let newUser: CreateUserRequest = {
                  email: mail,
                  password: hashedPw,
                  companyId: companyId,
                  creatorRoleId: this.data.user.roleId,
                  creatorCompanyId: this.data.user.companyId
                };

                this.dialogRef.close({ save: true, data: newUser });
              }
              else {
                this.errors = response.errors;
              }
            });
        } else {
          this.errors = ["The limit of active users has been reached, this action can't be performed."];
        }
      });
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}